import * as React from "react";

import { ComponentMap } from "../tools/hydrator/@types/hydrator.types";

const LanguageSelector = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/General/LanguageSelector/languageSelector.container"
    ).then(module => ({
        default: module.LanguageSelectorContainer,
    })),
);
const FlyoutButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Navigation/Flyout/flyoutButton.container"
    ).then(module => ({
        default: module.FlyoutButtonContainer,
    })),
);
const SafetyInfo = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/SafetyInfo/safetyInfo.container"
    ).then(module => ({
        default: module.SafetyInfoContainer,
    })),
);
const ImageViewer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ImageViewer/imageViewer.container"
    ).then(module => ({
        default: module.ImageViewerContainer,
    })),
);
const ImageViewerFullWidth = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Product/ImageViewerFullWidth/imageViewerFullWidth.container"
    ).then(module => ({
        default: module.ImageViewerFullWidthContainer,
    })),
);
const ProductSlider = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ProductSlider/productSlider.container"
    ).then(module => ({
        default: module.ProductSliderContainer,
    })),
);
const ProductList = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ProductList/productList.container"
    ).then(module => ({
        default: module.ProductListContainer,
    })),
);
const ProductTileAdapter = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ProductTile/productTile.adapter"
    ).then(module => ({
        default: module.ProductTileAdapter,
    })),
);
const Categories = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/Categories/categorySlider.container"
    ).then(module => ({
        default: module.CategoriesContainer,
    })),
);
const AccountButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/AccountButton/accountButton.container"
    ).then(module => ({
        default: module.AccountButtonContainer,
    })),
);
const ProductComparisonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ProductComparison/productComparison.container"
    ).then(module => ({
        default: module.ProductComparisonContainer,
    })),
);
const ProductComparisonBar = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ProductComparisonBar/productComparisonBar.container"
    ).then(module => ({
        default: module.ProductComparisonBarContainer,
    })),
);
const WishlistHeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Wishlist/WishlistHeaderButton/wishlistHeaderButton.container"
    ).then(module => ({
        default: module.WishlistHeaderButtonContainer,
    })),
);
const CartButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/CartButton/cartButton.container"
    ).then(module => ({
        default: module.CartButtonContainer,
    })),
);
const HeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/HeaderButton/headerButton.container"
    ).then(module => ({
        default: module.HeaderButtonContainer,
    })),
);
const DebugNotification = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Utils/debugNotifiction/debugNotification.component"
    ).then(module => ({
        default: module.DebugNotification,
    })),
);
const ECommerce = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ECommerce/eCommerce.container"
    ).then(module => ({
        default: module.ECommerceContainer,
    })),
);
const AlgoliaSearch = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Search/SearchAutocomplete/searchAutocomplete.wrapper"
    ).then(module => ({
        default: module.SearchAutocompleteWrapper,
    })),
);
const ProductBundles = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ProductBundles/productBundles.container"
    ).then(module => ({
        default: module.ProductBundles,
    })),
);

const ProductPage = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/ProductPage/productPage.container"
    ).then(module => ({
        default: module.ProductPageContainer,
    })),
);

const StoreLocatorMobile = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/StoreLocatorMobile/storeLocatorMobile.container"
    ).then(module => ({
        default: module.StoreLocatorMobileContainer,
    })),
);

const CallToAction = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/CallToAction/callToAction.container"
    ).then(module => ({
        default: module.CallToAction,
    })),
);

const FeatureSwitchContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Utils/featureSwitch/featureSwitch.container"
    ).then(module => ({
        default: module.FeatureSwitchContainer,
    })),
);

const StoreSearchContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Store/StoreSearch/storeSearch.container"
    ).then(module => ({
        default: module.StoreSearch,
    })),
);

const StoreDirections = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Store/StoreDirections/storeDirections.container"
    ).then(module => ({
        default: module.StoreDirections,
    })),
);

const NewsletterContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Newsletter/newsletter.container"
    ).then(module => ({
        default: module.NewsLetterContainer,
    })),
);

const LoginFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/LoginForm/loginForm.container"
    ).then(module => ({
        default: module.LoginFormContainer,
    })),
);

const RegisterFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/RegisterForm/registerForm.container"
    ).then(module => ({
        default: module.RegisterFormContainer,
    })),
);

const ForgotPasswordFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/ForgotPasswordForm/forgotPasswordForm.container"
    ).then(module => ({
        default: module.ForgotPasswordForm,
    })),
);

const ResetPasswordFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/ResetPasswordForm/resetPasswordForm.container"
    ).then(module => ({
        default: module.ResetPasswordFormContainer,
    })),
);

const RegisterCheckoutFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Checkout/RegisterCheckoutForm/registerCheckoutForm.container"
    ).then(module => ({
        default: module.RegisterCheckoutForm,
    })),
);

const FranchiseRequestContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/FranchiseRequest/franchiseRequest.container"
    ).then(module => ({
        default: module.FranchiseRequestContainer,
    })),
);

const ContactCustomerserviceContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/ContactCustomerservice/contactCustomerservice.container"
    ).then(module => ({ default: module.ContactCustomerserviceContainer })),
);

const CreateGiftCardContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/CreateGiftCard/createGiftCard.container"
    ).then(module => ({ default: module.CreateGiftCardContainer })),
);

const BusinessGiftCardRequestContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/BusinessGiftCardRequest/businessGiftCardRequest.container"
    ).then(module => ({ default: module.BusinessGiftCardRequestContainer })),
);

const GiftCardRequestBalanceContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/GiftCardRequestBalance/giftCardRequestBalance.container"
    ).then(module => ({
        default: module.GiftCardRequestBalanceContainer,
    })),
);

const BonusCardRequestContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/BonusCardRequest/bonusCardRequest.container"
    ).then(module => ({ default: module.BonusCardRequestContainer })),
);

const BonusCardRequestBalanceContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/BonusCardRequestBalance/bonusCardRequestBalance.container"
    ).then(module => ({ default: module.BonusCardRequestBalanceContainer })),
);

const CustomerLoad = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Customer/load.component"
    ).then(module => ({ default: module.CustomerLoad })),
);

const QuizziAppointment = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/ContactQuizzi/quizziAppointment.container"
    ).then(module => ({ default: module.QuizziAppointment })),
);

const SearchResults = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Search/SearchResults/searchResults.container"
    ).then(module => ({ default: module.SearchResults })),
);

//keys here match the enum name from -> be.hubo.hubofoundation.ssr.SsrComponentName
export const componentMap: ComponentMap = {
    HEADER_BUTTON: HeaderButton,
    ACCOUNT_BUTTON: AccountButton,
    CART_BUTTON: CartButton,
    WISHLIST_HEADER_BUTTON: WishlistHeaderButton,
    PRODUCT_COMPARISON: ProductComparisonContainer,
    PRODUCT_COMPARISON_BAR: ProductComparisonBar,
    LANGUAGE_SELECTOR: LanguageSelector,
    FLYOUT_BUTTON: FlyoutButton,
    SAFETY_INFO: SafetyInfo,
    IMAGE_VIEWER: ImageViewer,
    IMAGE_VIEWER_FULL_WIDTH: ImageViewerFullWidth,
    PRODUCT_SLIDER: ProductSlider,
    PRODUCT_TILE: ProductTileAdapter,
    PRODUCT_LIST: ProductList,
    CATEGORIES_SLIDER: Categories,
    DEBUG_NOTIFICATION: DebugNotification,
    ECOMMERCE: ECommerce,
    SEARCH_BAR: AlgoliaSearch,
    PRODUCT_BUNDLES: ProductBundles,
    STORE_LOCATOR_MOBILE: StoreLocatorMobile,
    CALL_TO_ACTION: CallToAction,
    PRODUCT_PAGE: ProductPage,
    FEATURE_SWITCH: FeatureSwitchContainer,
    STORE_SEARCH: StoreSearchContainer,
    STORE_DIRECTIONS: StoreDirections,
    NEWSLETTER: NewsletterContainer,
    LOGIN_FORM: LoginFormContainer,
    REGISTER_FORM: RegisterFormContainer,
    FORGOT_PASSWORD_FORM: ForgotPasswordFormContainer,
    REGISTER_CHECKOUT_FORM: RegisterCheckoutFormContainer,
    FRANCHISE_REQUEST: FranchiseRequestContainer,
    CONTACT_CUSTOMER_SERVICE: ContactCustomerserviceContainer,
    CREATE_GIFT_CARD: CreateGiftCardContainer,
    BUSINESS_GIFT_CARD_REQUEST: BusinessGiftCardRequestContainer,
    GIFT_CARD_REQUEST_BALANCE: GiftCardRequestBalanceContainer,
    BONUS_CARD_REQUEST: BonusCardRequestContainer,
    BONUS_CARD_REQUEST_BALANCE: BonusCardRequestBalanceContainer,
    CUSTOMER_LOAD: CustomerLoad,
    QUIZZI_APPOINTMENT: QuizziAppointment,
    SEARCH_RESULTS: SearchResults,
};
